/**
 * Canonical ID normalization - uses exact Firestore doc IDs.
 * No aliases; trim only.
 */

/** Output of normalizeRoleId — UPPERCASE global role id. */
export type NormalizedGlobalRoleId = string;

/**
 * Firestore `/team_roles` doc id — case-sensitive (e.g. ETHIC, med_error, OCC_paricipant).
 * Rules often compare with `.lower()`; keep stored ids aligned with Role breakdown table.
 */
export type TeamRoleDocId = string;

/**
 * Normalize role ID to UPPERCASE for /roles collection.
 */
export function normalizeRoleId(id: string | undefined | null): string | undefined {
  if (id == null || typeof id !== 'string') return undefined;
  const trimmed = id.trim();
  if (!trimmed) return undefined;
  return trimmed.toUpperCase();
}

/**
 * Team role ID - exact Firestore /team_role doc ID. No aliases.
 */
export function normalizeTeamRoleId(id: string | undefined | null): string | undefined {
  if (id == null || typeof id !== 'string') return undefined;
  const trimmed = id.trim();
  return trimmed || undefined;
}

/**
 * Compliance category ID - exact Firestore /complianceCategories doc ID. No aliases.
 */
export function normalizeComplianceCategoryId(id: string | undefined | null): string | undefined {
  if (id == null || typeof id !== 'string') return undefined;
  const trimmed = id.trim();
  return trimmed || undefined;
}
